<template>
  <div>
    <div>
      <div v-if="mode==0">
        <!-- 直近 -->
        <div class="graph-menu-content show">
          <ul class="graph-menu-list">
            <li v-bind:class="{'active': isActive[0]}"><a @click="changeshownumber(10); changeisActive(10); graph_clear(); reverserefreshflag()">{{$t("app.dashboard.graph.datetimepicker.latest.ten")}}</a></li>
            <li v-bind:class="{'active': isActive[1]}"><a @click="changeshownumber(50); changeisActive(50); graph_clear(); reverserefreshflag()">{{$t("app.dashboard.graph.datetimepicker.latest.fifty")}}</a></li>
            <li v-bind:class="{'active': isActive[2]}"><a @click="changeshownumber(100); changeisActive(100); graph_clear(); reverserefreshflag()">{{$t("app.dashboard.graph.datetimepicker.latest.one_hundred")}}</a></li>
            <li v-bind:class="{'active': isActive[3]}"><a @click="changeshownumber(200); changeisActive(200); graph_clear(); reverserefreshflag()">{{$t("app.dashboard.graph.datetimepicker.latest.two_hundred")}}</a></li>
            <li v-bind:class="{'active': isActive[4]}"><a @click="changeshownumber(400); changeisActive(400); graph_clear(); reverserefreshflag()">{{$t("app.dashboard.graph.datetimepicker.latest.four_hundred")}}</a></li>
            <li v-bind:class="{'active': isActive[5]}"><a @click="changeshownumber(800); changeisActive(800); graph_clear(); reverserefreshflag()">{{$t("app.dashboard.graph.datetimepicker.latest.eight_hundred")}}</a></li>
            <li v-bind:class="{'active': isActive[6]}"><a @click="changeshownumber(1600); changeisActive(1600); graph_clear(); reverserefreshflag()">{{$t("app.dashboard.graph.datetimepicker.latest.one_thousand_six_hundred")}}</a></li>
          </ul>
        </div>
      </div>
      <div v-else-if="mode==1">
        <!-- 相対値 -->
        <div class="graph-menu-content2 show">
          <ul class="graph-menu-list2">
            <li v-bind:class="{'active': isActive2[0]}"><a @click="changerelativetime(5); changeisActive2(5); setRerender()">{{$t("app.dashboard.graph.datetimepicker.recently.five_m")}}</a></li>
            <li v-bind:class="{'active': isActive2[1]}"><a @click="changerelativetime(15); changeisActive2(15); setRerender()">{{$t("app.dashboard.graph.datetimepicker.recently.fifteen_m")}}</a></li>
            <li v-bind:class="{'active': isActive2[2]}"><a @click="changerelativetime(60); changeisActive2(60); setRerender()">{{$t("app.dashboard.graph.datetimepicker.recently.one_h")}}</a></li>
            <li v-bind:class="{'active': isActive2[3]}"><a @click="changerelativetime(180); changeisActive2(180); setRerender()">{{$t("app.dashboard.graph.datetimepicker.recently.three_h")}}</a></li>
            <li v-bind:class="{'active': isActive2[4]}"><a @click="changerelativetime(360); changeisActive2(360); setRerender()">{{$t("app.dashboard.graph.datetimepicker.recently.six_h")}}</a></li>
            <li v-bind:class="{'active': isActive2[5]}"><a @click="changerelativetime(720); changeisActive2(720); setRerender()">{{$t("app.dashboard.graph.datetimepicker.recently.twenty_h")}}</a></li>
            <li v-bind:class="{'active': isActive2[6]}"><a @click="changerelativetime(1440); changeisActive2(1440); setRerender()">{{$t("app.dashboard.graph.datetimepicker.recently.twentyfour_h")}}</a></li>
            <li v-bind:class="{'active': isActive2[7]}"><a @click="changerelativetime(4320); changeisActive2(4320); setRerender()">{{$t("app.dashboard.graph.datetimepicker.recently.three_d")}}</a></li>
            <li v-bind:class="{'active': isActive2[8]}"><a @click="changerelativetime(7200); changeisActive2(7200); setRerender()">{{$t("app.dashboard.graph.datetimepicker.recently.five_d")}}</a></li>
          </ul>
        </div>

      </div>
      <div v-else-if="mode==2" class="level-left">
        <!-- 絶対値 -->
        <b-datetimepicker
          :placeholder="$t('app.dashboard.graph.datetimepicker.span.start')"
          icon="calendar-today"
          editable
          size="is-medium"
          v-model="since_"
        />
        <div class="from_to">
          <b-icon icon="tilde"></b-icon>
        </div>
        <b-datetimepicker
          class="level-item"
          :placeholder="$t('app.dashboard.graph.datetimepicker.span.end')"
          icon="calendar-today"
          editable
          size="is-medium"
          v-model="until_"
        />
        <b-button
          v-if="since_ != null && until_ != null && ( since_.getTime() <= until_.getTime() )"
          class="button is-primary level-item"
          size="is-medium"
          @click="setdatamode(2); getDate(); setRerender()"
          @event.prevent
        >
          {{$t("app.dashboard.graph.datetimepicker.span.submit")}}
        </b-button>
        <b-button
          v-if="since_ == null || until_ == null || ( since_.getTime() > until_.getTime() )"
          class="button is-primary level-item"
          size="is-medium"
          @click="warnRange(); warnNull();"
          @event.prevent
        >
          {{$t("app.dashboard.graph.datetimepicker.span.submit")}}
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment-timezone";
import { mapState } from "vuex";

export default {
  data() {
    return {
      since_: null,
      until_: new Date(moment().tz(moment.tz.guess()).format('YYYY-MM-DD HH:mm'))
    };
  },
  computed: {
    ...mapState({
      since: state => state.graph.options.since ? state.graph.options.since.format("YYYY-MM-DDTHH:mm") : null,
      until: state => state.graph.options.until ? state.graph.options.until.format("YYYY-MM-DDTHH:mm") : null,
      isActive: state => state.graph.options.isActive,
      isActive2: state => state.graph.options.isActive2,
      mode: state => state.graph.options.pickstatus,
      shownumber: state => state.graph.options.shownumber,
      datamode: state => state.graph.options.datamode,
      refreshflag: state => state.graph.options.refreshflag
    })
  },
  mounted() {
    if (this.datamode == "absolute_mode") {
      this.since_ = new Date(this.since)
      this.until_ = new Date(this.until)
    }
  },
  methods: {
    getDate: function() {
      this.$store.dispatch("graph/setMinutes", 0)
      if (this.since_ !== this.since || this.until_ !== this.until) {
        if(this.since_ !== null && this.until_ !== null){
          if (moment(this.until_).isBefore(this.since_) == false) {
            this.$store.dispatch("graph/setSince", moment(this.since_));
            this.$store.dispatch("graph/setUntil", moment(this.until_));
          }
        }
      }
    },
    warnRange() {
      if (moment(this.until_).isBefore(this.since_)) {
        this.$buefy.toast.open({
          duration: 2000,
          message: this.$t('app.dashboard.graph.datetimepicker.warn.range'),
          position: "is-top",
          type: "is-danger"
        })
      }
    },
    warnNull(){
      if(this.since_ == null || this.until_ == null){
        this.$buefy.toast.open({
          duration: 2000,
          message: this.$t('app.dashboard.graph.datetimepicker.warn.null'),
          position: "is-top",
          type: "is-danger"
        })
      }
    },
    changerelativetime(num) {
      this.$store.dispatch("graph/setDatamode", "latest_mode"),
      this.$store.dispatch("graph/setRelativeTime", num)
      this.$store.dispatch("graph/setMinutes", num)
    },
    changeshownumber(num) {
      this.$store.dispatch("graph/setDatamode", "limit_mode"),
      this.$store.dispatch("graph/setShowNumber", num)
    },
    changeisActive(num){
      this.$store.dispatch("graph/setIsActive2", [0,0,0,0,0,0,0,0,0]);
      this.isActive2 = [0,0,0,0,0,0,0,0,0]
      switch(num){
        case 10:
          this.$store.dispatch("graph/setIsActive", [1,0,0,0,0,0,0]);
          break;
        case 50:
          this.$store.dispatch("graph/setIsActive", [0,1,0,0,0,0,0]);
          break;
        case 100:
          this.$store.dispatch("graph/setIsActive", [0,0,1,0,0,0,0]);
          break;
        case 200:
          this.$store.dispatch("graph/setIsActive", [0,0,0,1,0,0,0]);
          break;
        case 400:
          this.$store.dispatch("graph/setIsActive", [0,0,0,0,1,0,0]);
          break;
        case 800:
          this.$store.dispatch("graph/setIsActive", [0,0,0,0,0,1,0]);
          break;
        case 1600:
          this.$store.dispatch("graph/setIsActive", [0,0,0,0,0,0,1]);
          break;
        default:
          break;
      }
    },
    changeisActive2(num){
      this.$store.dispatch("graph/setIsActive", [0,0,0,0,0,0,0]);
      this.isActive = [0,0,0,0,0,0,0]
      switch(num){
        case 5:
          this.$store.dispatch("graph/setIsActive2", [1,0,0,0,0,0,0,0,0]);
          break;
        case 15:
          this.$store.dispatch("graph/setIsActive2", [0,1,0,0,0,0,0,0,0]);
          break;
        case 60:
          this.$store.dispatch("graph/setIsActive2", [0,0,1,0,0,0,0,0,0]);
          break;
        case 180:
          this.$store.dispatch("graph/setIsActive2", [0,0,0,1,0,0,0,0,0]);
          break;
        case 360:
          this.$store.dispatch("graph/setIsActive2", [0,0,0,0,1,0,0,0,0]);
          break;
        case 720:
          this.$store.dispatch("graph/setIsActive2", [0,0,0,0,0,1,0,0,0]);
          break;
        case 1440:
          this.$store.dispatch("graph/setIsActive2", [0,0,0,0,0,0,1,0,0]);
          break;
        case 4320:
          this.$store.dispatch("graph/setIsActive2", [0,0,0,0,0,0,0,1,0]);
          break;
        case 7200:
          this.$store.dispatch("graph/setIsActive2", [0,0,0,0,0,0,0,0,1]);
          break;
        default:
          break;
      }
    },
    setdatamode(n){
      if(n == 0) {
        this.$store.dispatch("graph/setDatamode", "limit_mode")
      }else if(n == 1) {
        this.$store.dispatch("graph/setDatamode", "latest_mode")
      }else if(n == 2) {
        this.$store.dispatch("graph/setDatamode", "absolute_mode")
        this.$store.dispatch("graph/setIsActive", [0,0,0,0,0,0,0]);
        this.$store.dispatch("graph/setIsActive2", [0,0,0,0,0,0,0,0,0]);
      }
    },
    reverserefreshflag(){
      this.$store.dispatch("graph/setrefreshflag", !this.refreshflag)
    },
    setRerender(){
      this.$store.dispatch("graph/setRerender", true)
      this.reverserefreshflag()
      this.$store.dispatch("graph/setShowNumber", null)
    },
    graph_clear(){
      this.$store.dispatch("graph/clear") //since,untilが変更されるのでsubscribeでグラフ描画が走る
    }
  }
};
</script>
<style>
  .from_to{
    margin: 0px 10px;
  }
  .graph-menu-content {
    display: none;
  }
  .graph-menu-content.show {
    display: block;
  }
  .graph-menu-list {
    display: flex;
    justify-content: space-between;
    margin: auto;
  }
  .graph-menu-list li a {
    display: inline-block;
    margin: 0 25px;
    height: 40px;
    line-height: 40px;
    text-decoration: none;
  }
  .graph-menu-list li.active a {
    padding: 0 20px;
    background: #2c6ac4;
    color: #fff;
    border-radius: 4px;
    font-weight: bold;
  }

  .graph-menu-content2 {
    display: none;
  }
  .graph-menu-content2.show {
    display: block;
  }
  .graph-menu-list2 {
    display: flex;
    justify-content: space-between;
    margin: auto;
  }
  .graph-menu-list2 li a {
    display: inline-block;
    margin: 0 25px;
    height: 40px;
    line-height: 40px;
    text-decoration: none;
  }
  .graph-menu-list2 li.active a {
    padding: 0 20px;
    background: #2c6ac4;
    color: #fff;
    border-radius: 4px;
    font-weight: bold;
  }
</style>
